import "./text-input-group.css.js";
const p = {
  labelGroupMain: "pf-v6-c-label-group__main",
  modifiers: {
    disabled: "pf-m-disabled",
    plain: "pf-m-plain",
    success: "pf-m-success",
    warning: "pf-m-warning",
    error: "pf-m-error",
    icon: "pf-m-icon",
    status: "pf-m-status",
    hint: "pf-m-hint"
  },
  textInputGroup: "pf-v6-c-text-input-group",
  textInputGroupGroup: "pf-v6-c-text-input-group__group",
  textInputGroupIcon: "pf-v6-c-text-input-group__icon",
  textInputGroupMain: "pf-v6-c-text-input-group__main",
  textInputGroupText: "pf-v6-c-text-input-group__text",
  textInputGroupTextInput: "pf-v6-c-text-input-group__text-input",
  textInputGroupUtilities: "pf-v6-c-text-input-group__utilities"
};
export {
  p as default
};
